import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import DragScrollTabsComponent from "./components/DragScrollTabsComponent";
import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

export const ProductosPage = () => {

    const { t, i18n } = useTranslation();

    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(t("all"));
    const [products, setProducts] = useState([]);

    const categorias = [t("all"), t("fruits"), t("vegetables"), t("hortalizas")];

    const productosFiltrados =
        categoriaSeleccionada === t("all")
            ? products
            : products.filter(
                (producto) => producto.categoria === categoriaSeleccionada
            );

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        import(`../../core/data/${i18n.language}Productos.json`)
            .then((module) => setProducts(module.default))
            .catch((err) => console.error("Error loading products", err));
        setCategoriaSeleccionada(t("all"))
    }, [i18n.language]);

    useEffect(() => {
        new WOW.WOW().init();
    }, [productosFiltrados]);

    return (
        <>
            <section>
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">Productos</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section className="section">
                <div className='container p-0'>

                    <DragScrollTabsComponent
                        categoriasData={categorias}
                        categoriaSeleccionada={categoriaSeleccionada}
                        setCategoriaSeleccionada={setCategoriaSeleccionada}
                    />

                    <div className="row row-cols-1 row-cols-md-3 row-cols-sm-2 row-cols-lg-4 p-0">
                        {
                            productosFiltrados.map((item, index) => {
                                return (
                                    <div className="col d-flex justify-content-center mb-5 wow flipInX" key={index}>
                                        <div className='card-product shadow-default py-3'>
                                            <div className='image-product-card'>
                                                <img className="" src={`assets/img/products/${item.imagen}`} />
                                            </div>
                                            <div className='card-product-body'>

                                                <div className="card-product-info">
                                                    <p className='sub-title-product mx-3 mt-0'>{item.categoria}</p>
                                                    <h1 className='title-product mx-3'>{item.nombre}</h1>
                                                </div>

                                                <div className='card-product-footer d-flex justify-content-center mx-3 mt-3'>
                                                    {/* <p className='' style={{ color: "#b2b2b2ff" }}>{item.unidadMedida}</p> */}
                                                    {/* <label className='badge-product'>Ver producto</label> */}
                                                    <Link
                                                        to={`/productos/${item.slug}`}
                                                        className={`default-btn`}>
                                                        {t("seeProduct")}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}